import { Component, Vue } from 'vue-property-decorator';
import { IDraft, IDraftPick } from '@/store/modules/draft/interfaces';
import OverUnderResult from './OverUnderResult';
import HeadToHeadResult from './HeadToHeadResult';
import { GetOUFantasyAspect, FormatDate, StatusFormat, FormatCurrency, GetWinningPicks, GetPlayerPosition } from '@/utils/GameUtils';
import { IPick, IPlayer } from '@/store/modules/game/interfaces';
import StatsService from '@/services/StatsService';
import _ from 'lodash';

@Component
export default class DraftDetail extends Vue {
  private draft: IDraft
  private isFetching: boolean = true

  private created() {
    const cached = this.$store.getters.ACCESSDRAFTS[0]

    if (cached) {
      this.draft = this.$store.getters.ACCESSDRAFTS.all.filter( (d: IDraft) => { return d.id === this.$route.params.id })[0]
      this.isFetching = false
    } else {
      this.$store.dispatch('SET_LOADINGSTATE', true)
      this.$store.dispatch('GET_DRAFTS', this.$route.params.chunk).then( draftList => {
        this.draft = draftList.all.filter( (d: IDraft) => { return d.id === this.$route.params.id })[0]
        this.isFetching = false
        this.$store.dispatch('SET_LOADINGSTATE', true)
      })
    }
  }

  statsFor(pickA: IPick, pickB: IPick) {
    let stats

    if (pickB.player.aspect.id.toLowerCase() === 'ou') {
      stats = StatsService.generateStatsForMatchup(pickB, pickA, true);
    } else {
      stats = StatsService.generateStatsForMatchup(pickA, pickB, true);
    }

    function endsWithAny(suffixes: string[], input: string): boolean {
      return suffixes.some(function (suffix) {
          return input.endsWith(suffix);
      });
    }

    function sanitise(stats: any[]) {

      var clean = _.filter(_.compact(stats), function(s) {
        if (s.shortName === 'GP') return

        return s.value > 0 || s.presentAs
      });

      var pick = _.map(clean, function(c) {

        if (pickA.player.aspect.name.toLowerCase() === 'nascar') {
          if (endsWithAny(['st', 'nd', 'rd', 'th'], c.shortName)) {
            return `${c.shortName} Place`
          }
        }

        if (c.shortName) {
          return c.value + ' ' + c.shortName;
        } else {
          return c.value;
        }
      });

      return [pick.slice(0, 3).join(', '), pick.slice(3, pick.length).join(', ')];
    }

    function mlbHitterStatMunge(stats: any[]) {
      let statList = stats;

      let hits = _.find(statList, function(s) { return s.shortName === 'H'; });
      let bats = _.find(statList, function(s) { return s.shortName === 'AB'; });
      
      if (hits && bats) {
        let toAdd = {
          value: hits.value + '/' + bats.value,
          shortName: null
        };

        let filtered = _.filter(statList, function(s) {
          return s.shortName !== 'H' && s.shortName !== 'AB' && s.shortName !== 'IPO';
        });

        filtered.unshift(toAdd);
        return filtered;
      } else {
        return statList;
      }
    }

    if (!stats) return {
      a: [],
      b: []
    }; 

    if (pickA.player.aspect.name.toLowerCase() === 'mlb') {

      return {
        a: sanitise(mlbHitterStatMunge(stats.a)),
        b: sanitise(mlbHitterStatMunge(stats.b))
      };

    } else {

      return {
        a: sanitise(stats.a),
        b: sanitise(stats.b)
      };
    }
  }

  private matchupSettled(pick: IDraftPick) {
    var status = pick.status;
    return status === 'winner' || status === 'loser'
  }

  private matchupVoid(pick: IDraftPick) {
    return pick.status === 'void'
  }

  private matchupTie(pick: IDraftPick) {
    return pick.status === 'void' && pick.matchup.reason === 'TIE'
  }

  private render(h: any): any {
    if (this.isFetching) {
      return
    }

    const pickRender = this.draft.json.picks.map( (pick) => {
      if (GetOUFantasyAspect(pick.matchup.pickB) === 'ou') {
        // @ts-ignore
        return (<OverUnderResult draftPick={pick}></OverUnderResult>)
      } else {
        // @ts-ignore
        return (<HeadToHeadResult draftPick={pick}></HeadToHeadResult>)
      }
    });

    return (
      <section>
        <table class='qp-drafts'>
          <tr class='qp-drafts-header-row'>
            <th class='hide-small'>Placed</th>
            <th>Status</th>
            <th>Picks</th>
            <th>Fee</th>
            <th>Winners</th>
            <th>Winnings</th>
          </tr>
          <tr class='qp-drafts-data-row'>
            <td class='hide-small'>{FormatDate(this.draft.placetime)}</td>
            <td>{StatusFormat(this.draft.json.status)}</td>
            <td>{this.draft.json.picks.length}</td>
            <td class='last'>{FormatCurrency(this.draft.json.fee)}</td>
            <td>{GetWinningPicks(this.draft)}</td>
            <td>{FormatCurrency(this.draft.json.winnings)}</td>
          </tr>
        </table>
        <div class='qp-drafts-data-list'>
        {pickRender}
        </div>
      </section>
    );
  }
}
